import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import moment from "moment";
import { translate, translateWithParams } from "../localization/translateService";
import { getPopupAdsByPage } from "../services/popupService";
import { modifyMediaUrl } from "../helpers/modifyMediaUrl";
import { ADS_DISPLAY_PAGE_ID, ADS_NO_DISPLAY_PAGE_ID, LANDING_HEADER_NAVIGATION_HREF, LANDING_TOPIK_ROUTE } from "../constants/app-constants";

export default function AdvertiseModal() {
  const [dialogVisible, setDialogVisible] = useState(false);
  const [snoozeChecked, setSnoozeChecked] = useState(false);
  const [adsData, setAdsData] = useState(null);

  const [translations, setTranslations] = useState({
    snoozeCheckboxTitle: "",
    closeButtonLabel: "",
  });

  const handleClickSnoozeCheckbox = (checked) => {
    const storedName = `${ADS_NO_DISPLAY_PAGE_ID}_${adsData?.displayPage}`;
    if (checked) {
      setSnoozeChecked(true);
      if (adsData?.displayPage != null) {
        window.localStorage.setItem(
          storedName,
          JSON.stringify({
            adsPageId: adsData.displayPage,
            snoozeEndDate: moment().add(adsData?.snoozePeriod, "days").toISOString(),
          })
        );
      }
      return;
    }
    window.localStorage.removeItem(storedName);
    setSnoozeChecked(false);
  };

  const handleClickAds = () => {
    if (adsData?.targetUrl) {
      window.open(adsData.targetUrl, "_blank");
    }
  };

  const loadTranslations = async (snoozePeriod = 0) => {
    const snoozeCheckboxTitle = await translateWithParams("ADS_DIALOG.SNOOZE_CHECKBOX.TITLE", { count: snoozePeriod }, true);
    const closeButtonLabel = await translate("ADS_DIALOG.BUTTON.CLOSE", true);

    setTranslations({
      snoozeCheckboxTitle,
      closeButtonLabel,
    });
  };

  const getAdsPageId = (pathname) => {
    const segments = pathname.split("/").filter(Boolean);
    const fullSegment = `/${segments?.[1] ?? ""}${segments?.[2] ? `/${segments?.[2]}` : "" }`;
    for (const route of Object.values(LANDING_HEADER_NAVIGATION_HREF)) {
      if (fullSegment === route) {
        return ADS_DISPLAY_PAGE_ID[route] || null;
      }
    }
    return null;
  };

  const fetchData = async () => {
    const adsPageId = getAdsPageId(window.location.pathname);
    if (adsPageId === null) return;

    const storedName = `${ADS_NO_DISPLAY_PAGE_ID}_${adsPageId}`;
    const storedNoDisplayPageRawData = window.localStorage.getItem(storedName);
    const storedNoDisplayPageParsedData = storedNoDisplayPageRawData ? JSON.parse(storedNoDisplayPageRawData) : null;
    const storedAdsPageId = Number(storedNoDisplayPageParsedData?.adsPageId);
    const storedSnoozeEndDate = moment(storedNoDisplayPageParsedData?.snoozeEndDate, moment.ISO_8601, true);
    if (!isNaN(storedAdsPageId) && adsPageId === storedAdsPageId && storedSnoozeEndDate.isValid()) {
      if (moment().isBefore(storedSnoozeEndDate)) {
        return;
      }
      if (moment().isAfter(storedSnoozeEndDate)) {
        window.localStorage.removeItem(storedName);
      }
    }

    const data = await getPopupAdsByPage(adsPageId);

    if (data) {
      setAdsData(data);
      await loadTranslations(data?.snoozePeriod);
      const img = new Image();
      img.src = modifyMediaUrl(data?.imageUrl);
      img.onload = () => {
        setTimeout(() => {
          setDialogVisible(true);
        }, 2000);
      };
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <Dialog
        draggable={false}
        focusOnShow={false}
        visible={dialogVisible}
        className="keduall-advertise-modal"
        contentClassName="keduall-scrollbar"
        showHeader={false}
        footer={
          <div className="py-2 px-125 flex justify-content-between align-items-center">
            <div className="flex align-items-center p-2 gap-075" onClick={adsData?.enableSnooze ? (e) => {
              if (e.target.type !== 'checkbox') {
                handleClickSnoozeCheckbox(!snoozeChecked);
              }
            } : undefined}>
              {adsData?.enableSnooze && (
                <>
                  <input
                    id="checkbox"
                    type="checkbox"
                    checked={snoozeChecked}
                  />
                  <label htmlFor="checkbox" className="keduall-checkbox checkbox-base">
                    <i className="pi pi-check"></i>
                  </label>
                  <label htmlFor="checkbox" className="keduall-typography text-14-normal-400">{translations.snoozeCheckboxTitle}</label>
                </>
              )}
            </div>
            <Button className="keduall-buttons button-text-small-primary" onClick={() => setDialogVisible(false)}>
              <p className="keduall-typography text-14-semibold-600">
                {translations.closeButtonLabel}
              </p>
            </Button>
          </div>
        }
        onHide={() => {
          if (!dialogVisible) return;
          setDialogVisible(false);
        }}
        autoFocus={false}
        blockScroll={true}
        baseZIndex="10001"
      >
        <div>
          <div className="cursor-pointer" onClick={handleClickAds}>
            <img alt="ads" src={modifyMediaUrl(adsData?.imageUrl)} />
          </div>
        </div>
      </Dialog>
    </div>
  );
}
